/* eslint-disable no-lonely-if, no-unused-expressions */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment-timezone';
import Cookies from 'js-cookie';
import { isEqual } from 'lodash';
import { PrimaryButton, SecondaryButton } from '../buttonComponent/ButtonComponent';
import Text from '../text/Text';
import Checkbox from '../checkbox/Checkbox';
import InputTags from '../inputTags/InputTags';
import InputText from '../inputText/InputText';
import GeofenceActionUser from '../actionUser/GeofenceActionUser';
import TextArea from '../textAreaLimit/TextArea';
import TimeSelector from '../timeSelector/timeSelector';
import { APIGetV3TeamMembers } from '../../config/restAPI/FetchAPI';
import { APICreateAlertPolicy } from '../../config/restAPI/PostAPI';
import { APIPatchAlertPolicy } from '../../config/restAPI/PatchAPI';
import './alerts.css';

export default function BatteryStatusAlert(props) {
    const { detailsRow, selectionList } = props;
    const token = Cookies.get('jwtToken');
    const agencyID = Cookies.get('agencyUUID');
    const listAgency = JSON.parse(localStorage.getItem('listAgency') || '[]');
    const currentAgencyTimezone = listAgency.find((a) => a.agency.oid === agencyID)?.agency?.agencyTz || 'Asia/Kuala_Lumpur';
    const [teamList, setTeamList] = useState([]);
    const [userRemove, setUserRemove] = useState([]);
    const [userAdd, setUserAdd] = useState([]);
    const [disabledAddUser, setDisabledAddUser] = useState(false);
    const [selectionUser, setSelectionUser] = useState({});
    const [selectedOption, setSelectedOption] = useState(null);
    const navigate = useNavigate();
    const [editingIndex, setEditingIndex] = useState(null);
    const [disableMainButton, setDisableMainButton] = useState(false);
    const [addAlertValue, setAddAlertValue] = useState({
        alertName: detailsRow?.alertName || '',
        batteryStatus: {
            lowBattery: {
                enabled: detailsRow?.batteryStatus?.lowBattery?.enabled || false,
                threshold: detailsRow?.batteryStatus?.lowBattery.threshold || '00',
                reIntervalDays: {
                    enabled: detailsRow?.batteryStatus?.lowBattery?.reIntervalDays.enabled || false,
                    days: detailsRow?.batteryStatus?.lowBattery?.reIntervalDays?.days || '0',
                },
            },
            criticalBattery: {
                enabled: detailsRow?.batteryStatus?.criticalBattery?.enabled || false,
                threshold: detailsRow?.batteryStatus?.criticalBattery.threshold || '00',
                reIntervalDays: {
                    enabled: detailsRow?.batteryStatus?.criticalBattery?.reIntervalDays.enabled || false,
                    days: detailsRow?.batteryStatus?.criticalBattery?.reIntervalDays?.days || '0',
                },
            },
            overVoltage: {
                enabled: detailsRow?.batteryStatus?.overVoltage?.enabled || false,
                threshold: detailsRow?.batteryStatus?.overVoltage.threshold || '00.00',
                reIntervalDays: {
                    enabled: detailsRow?.batteryStatus?.overVoltage?.reIntervalDays.enabled || false,
                    days: detailsRow?.batteryStatus?.overVoltage?.reIntervalDays?.days || '0',
                },
            },
        },
    });
    const [descriptionValue, setDescriptionValue] = useState(detailsRow?.description || '');
    const [listUser, setListUser] = useState(detailsRow?.notifiedUsers || []);
    const [tags, setTags] = useState(detailsRow?.associatedTags || []);
    const [removeTags, setRemoveTags] = useState([]);
    const [tagsHistory, setTagsHistory] = useState([]);
    const [loading, setLoading] = useState(false);
    const pageTotal = { totalPerPage: 100 };

    const inputOnChangeAlertName = (e) => {
        setAddAlertValue({
            ...addAlertValue,
            alertName: e.target.value,
        });
    };

    const handleCheckboxInputAlert = (e, type) => {
        const { checked } = e.target;

        setAddAlertValue((prev) => {
            const updatedState = {
                ...prev,
                batteryStatus: {
                    ...prev.batteryStatus,
                    lowBattery: type === 'lowBattery'
                        ? {
                            ...prev.batteryStatus.lowBattery,
                            enabled: checked,
                            reIntervalDays: {
                                ...prev.batteryStatus.lowBattery.reIntervalDays,
                                enabled: checked ? prev.batteryStatus.lowBattery.reIntervalDays.enabled : false,
                            },
                        }
                        : prev.batteryStatus.lowBattery,
                    criticalBattery: type === 'criticalBattery'
                        ? {
                            ...prev.batteryStatus.criticalBattery,
                            enabled: checked,
                            reIntervalDays: {
                                ...prev.batteryStatus.criticalBattery.reIntervalDays,
                                enabled: checked ? prev.batteryStatus.criticalBattery.reIntervalDays.enabled : false,
                            },
                        }
                        : prev.batteryStatus.criticalBattery,
                    overVoltage: type === 'overVoltage'
                        ? {
                            ...prev.batteryStatus.overVoltage,
                            enabled: checked,
                            reIntervalDays: {
                                ...prev.batteryStatus.overVoltage.reIntervalDays,
                                enabled: checked ? prev.batteryStatus.overVoltage.reIntervalDays.enabled : false,
                            },
                        }
                        : prev.batteryStatus.overVoltage,
                },
            };
            return updatedState;
        });
    };

    const handleCheckBoxReInterval = (e, type) => {
        const { checked } = e.target;

        setAddAlertValue((prev) => ({
            ...prev,
            batteryStatus: {
                ...prev.batteryStatus,
                [type]: {
                    ...prev.batteryStatus[type],
                    reIntervalDays: {
                        ...prev.batteryStatus[type].reIntervalDays,
                        enabled: checked,
                    },
                },
            },
        }));
    };

    const handlePercentageInput = (e, type) => {
        const inputVal = e.target.value;

        const isValidInput = (() => {
          if (type === 'overVoltage') {
            return /^(\d{1,2}(\.\d{0,2})?)?$/.test(inputVal); // allows up to 2 decimal places
          }
            return /^([0-9]{1,2})?$/.test(inputVal); // integer only, max 2 digits
        })();

        if (inputVal === '' || isValidInput) {
          setAddAlertValue((prev) => ({
            ...prev,
            batteryStatus: {
              ...prev.batteryStatus,
              lowBattery: type === 'lowBattery'
                ? {
                    ...prev.batteryStatus.lowBattery,
                    threshold: inputVal,
                  }
                : prev.batteryStatus.lowBattery,
              criticalBattery: type === 'criticalBattery'
                ? {
                    ...prev.batteryStatus.criticalBattery,
                    threshold: inputVal,
                  }
                : prev.batteryStatus.criticalBattery,
              overVoltage: type === 'overVoltage'
                ? {
                    ...prev.batteryStatus.overVoltage,
                    threshold: inputVal,
                  }
                : prev.batteryStatus.overVoltage,
            },
          }));
        }
      };

    const handleIntervalDaysInput = (e, type) => {
        const inputVal = e.target.value;

        if ((inputVal === '' || (/^[0-9]{1,2}$/.test(inputVal) && inputVal.length <= 1))) {
            setAddAlertValue((prev) => ({
                ...prev,
                batteryStatus: {
                    // ...prev.batteryStatus,
                    lowBattery: type === 'lowBattery'
                    ? {
                        ...prev.batteryStatus.lowBattery,
                        reIntervalDays: {
                            ...prev.batteryStatus.lowBattery.reIntervalDays,
                            days: inputVal,
                        },
                    } : prev.batteryStatus.lowBattery,
                    criticalBattery: type === 'criticalBattery'
                    ? {
                        ...prev.batteryStatus.criticalBattery,
                        reIntervalDays: {
                            ...prev.batteryStatus.criticalBattery.reIntervalDays,
                            days: inputVal,
                        },
                    } : prev.batteryStatus.criticalBattery,
                    overVoltage: type === 'overVoltage'
                    ? {
                        ...prev.batteryStatus.overVoltage,
                        reIntervalDays: {
                            ...prev.batteryStatus.overVoltage.reIntervalDays,
                            days: inputVal,
                        },
                    } : prev.batteryStatus.overVoltage,
                },
            }));
        }
    };

    const backButton = () => {
        navigate('/notifications/configuration', { replace: true });
        setListUser([]);
    };

    const fetchTeam = async (value) => {
        try {
            const result = await APIGetV3TeamMembers(setLoading, token, agencyID, value);
            if (result.data.status === 200) {
                const { data } = result.data;
                if (data.length > 0) {
                    const reducer = data.map((x) => ({
                        id: x.userFirstName || x.userLastName ? `${x.userFirstName} ${x.userLastName}` : '',
                        name: x.userEmail,
                        url: x?.profileImageUrl ? x.profileImageUrl : null,
                        channel: x?.channels?.length > 0 ? x.channels : [],
                        oid: x.oid,
                    }));
                    if (listUser.length > 0) {
                        const ids = new Set(listUser.map((r) => r.oid));
                        const updatedUser = reducer.filter((u) => !ids.has(u.oid));
                        setTeamList(updatedUser);
                    } else {
                        setTeamList(reducer);
                    }
                } else {
                    console.log('No data');
                }
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    };

    const createAlert = async (value) => {
        try {
            setDisableMainButton(true);
            const result = await APICreateAlertPolicy(token, setLoading, agencyID, value);
            if (result?.data?.status === 200) {
                setLoading(false);
                setDisableMainButton(false);
                navigate('/notifications/configuration', { state: { snackbarStatus: 'success', snackbarTitle: 'Success', snackbarSub: 'New Battery Status Alert Created!' } });
            } else {
                setLoading(false);
                setDisableMainButton(false);
                navigate('/notifications/configuration', { state: { snackbarStatus: 'error', snackbarTitle: 'Error', snackbarSub: `${result.response.data.status}: ${result.response.data.error.message}` } });
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
            setDisableMainButton(false);
        }
    };

    const updateAlert = async (value) => {
        try {
            setDisableMainButton(true);
            const result = await APIPatchAlertPolicy(token, setLoading, agencyID, value);
            if (result.data.status === 200) {
                setLoading(false);
                setDisableMainButton(false);
                navigate('/notifications/configuration', { state: { snackbarStatus: 'success', snackbarTitle: 'Success', snackbarSub: 'Battery Status Alert Updated!' } });
            } else {
                setDisableMainButton(false);
                setLoading(false);
                navigate('/notifications/configuration', { state: { snackbarStatus: 'error', snackbarTitle: 'Error', snackbarSub: `${result.error.code}:${result.error.message}` } });
            }
        } catch (err) {
            setDisableMainButton(false);
            console.log('Update Error');
            setLoading(false);
        }
    };

    useEffect(() => {
        if (listUser.length > 0) {
            fetchTeam(pageTotal);
        }
    }, [listUser]);

    useEffect(() => {
        if (token) {
            fetchTeam(pageTotal);
        }
    }, []);

    const saveUserButton = (selectionValue) => {
        if (detailsRow) {
            if (userAdd.length > 0) {
                const filterAdd = userAdd.filter((x) => x.oid === selectionValue.oid);
                if (filterAdd.length > 0) {
                    setUserAdd(filterAdd);
                } else {
                    setUserAdd([...userAdd, selectionValue]);
                }
            } else {
                setUserAdd([...userAdd, selectionValue]);
            }
        }
        const userWithAlertOn = {
            ...selectionValue,
            alertOn: selectionValue.alertOn || [],
        };
        setListUser([...listUser, userWithAlertOn]);
        setSelectionUser({});
        setDisabledAddUser(false);
    };

    const saveUpdateUserButton = (selectionValue, index) => {
        if (!selectionValue) return;
        if (detailsRow) {
            const existingUserIndex = userAdd.findIndex((x) => x.oid === selectionValue.oid);
            if (existingUserIndex !== -1) {
                const updatedUserAdd = [...userAdd];
                updatedUserAdd[existingUserIndex] = selectionValue;
                setUserAdd(updatedUserAdd);
            } else {
                setUserAdd([...userAdd, selectionValue]);
            }
        }
        const updatedListUser = [...listUser];
        if (index !== -1) {
            updatedListUser[index] = {
                ...updatedListUser[index],
                ...selectionValue,
                alertOn: selectionValue.alertOn || [],
            };
            setListUser(updatedListUser);
        }
        setSelectionUser({});
        setDisabledAddUser(false);
    };

    const addNewUser = () => {
        const user = {
            id: '',
            url: '',
            name: '',
            channels: [],
        };
        setSelectionUser(user);
        setDisabledAddUser(true);
    };

    const removeUser = (index, tagsValue) => {
        if (detailsRow) {
            if (userRemove.length > 0) {
                const filterRemove = userRemove.filter((x) => x.oid === tagsValue.oid);
                if (filterRemove.length > 0) {
                    setUserRemove(filterRemove);
                } else {
                    setUserRemove([...userRemove, tagsValue]);
                }
            } else {
                setUserRemove([...userRemove, tagsValue]);
            }
        }
        const removeArray = [...listUser];
        if (index !== -1) {
            removeArray.splice(index, 1);
            setListUser(removeArray);
        }
    };

    const editUser = (index, updatedUser) => {
        if (updatedUser) {
            const updatedListUser = [...listUser];
            if (index !== -1) {
                updatedListUser[index] = {
                    ...updatedListUser[index],
                    ...updatedUser,
                    alertOn: updatedUser.channel || [],
                };
                setListUser(updatedListUser);
            }
            setSelectionUser({});
            setDisableMainButton(false);
        }
    };

    const userCancel = () => {
        setEditingIndex(null);
        setSelectionUser({});
        setDisabledAddUser(false);
    };

    const checkingReducer = () => {
        const value = { alertPolicy: {} };

        value.alertPolicy.oid = detailsRow.oid;

        if (addAlertValue.alertName !== detailsRow.alertName) {
            value.alertPolicy.name = addAlertValue.alertName;
        }

        if (descriptionValue !== detailsRow.description) {
            value.alertPolicy.description = descriptionValue;
        }

        if (userRemove.length > 0) {
            value.alertPolicy.removeNotifiedUsers = userRemove.map((x) => x.oid);
        }

        if (userAdd.length > 0) {
            value.alertPolicy.addNotifiedUsers = userAdd.map((x) => ({
                userOid: x.oid,
                alertOn: x.alertOn || [],
            }));
        }

        if (tags.length > 0) {
            value.alertPolicy.addAssociatedTags = tags;
        }

        if (removeTags.length > 0) {
            value.alertPolicy.removeAssociatedTags = removeTags;
        }

        value.alertPolicy.batteryStatus = {
            lowBattery: {
                enabled: addAlertValue?.batteryStatus?.lowBattery?.enabled,
                threshold: addAlertValue?.batteryStatus?.lowBattery.threshold,
                reIntervalDays: {
                    enabled: addAlertValue?.batteryStatus?.lowBattery?.reIntervalDays.enabled,
                    days: addAlertValue?.batteryStatus?.lowBattery?.reIntervalDays?.days,
                },
            },
            criticalBattery: {
                enabled: addAlertValue?.batteryStatus?.criticalBattery?.enabled,
                threshold: addAlertValue?.batteryStatus?.criticalBattery.threshold,
                reIntervalDays: {
                    enabled: addAlertValue?.batteryStatus?.criticalBattery?.reIntervalDays.enabled,
                    days: addAlertValue?.batteryStatus?.criticalBattery?.reIntervalDays?.days,
                },
            },
            overVoltage: {
                enabled: addAlertValue?.batteryStatus?.overVoltage?.enabled,
                threshold: addAlertValue?.batteryStatus?.overVoltage.threshold,
                reIntervalDays: {
                    enabled: addAlertValue?.batteryStatus?.overVoltage?.reIntervalDays.enabled,
                    days: addAlertValue?.batteryStatus?.overVoltage?.reIntervalDays?.days,
                },
            },
        };

        return value;
    };

    const checkingButtonDisabled = () => {
        const value = {};

        if (addAlertValue.alertName !== detailsRow.alertName) {
            value.alertName = addAlertValue.alertName;
        }

        if (descriptionValue !== detailsRow.description) {
            value.description = descriptionValue;
        }

        if (userRemove.length > 0) {
            value.removeUsers = userRemove.map((x) => x.oid);
        }

        if (userAdd.length > 0) {
            value.addUsers = userAdd.map((x) => ({
                userOid: x.oid,
                alertOn: x.alertOn || [],
            }));
        }

        if (!isEqual(tags, detailsRow.associatedTags)) {
            value.addAssociatedTags = tags;
        }

        if (removeTags.length > 0) {
            value.removeAssociatedTags = removeTags;
        }

        const newBatteryStatus = {
            lowBattery: {
                enabled: addAlertValue?.batteryStatus?.lowBattery?.enabled,
                threshold: addAlertValue?.batteryStatus?.lowBattery.threshold,
                reIntervalDays: {
                    enabled: addAlertValue?.batteryStatus?.lowBattery?.reIntervalDays.enabled,
                    days: addAlertValue?.batteryStatus?.lowBattery?.reIntervalDays?.days,
                },
            },
            criticalBattery: {
                enabled: addAlertValue?.batteryStatus?.criticalBattery?.enabled,
                threshold: addAlertValue?.batteryStatus?.criticalBattery.threshold,
                reIntervalDays: {
                    enabled: addAlertValue?.batteryStatus?.criticalBattery?.reIntervalDays.enabled,
                    days: addAlertValue?.batteryStatus?.criticalBattery?.reIntervalDays?.days,
                },
            },
            overVoltage: {
                enabled: addAlertValue?.batteryStatus?.overVoltage?.enabled,
                threshold: addAlertValue?.batteryStatus?.overVoltage?.threshold,
                reIntervalDays: {
                    enabled: addAlertValue?.batteryStatus?.overVoltage?.reIntervalDays.enabled,
                    days: addAlertValue?.batteryStatus?.overVoltage?.reIntervalDays?.days,
                },
            },
        };

        if (!isEqual(newBatteryStatus, detailsRow.batteryStatus)) {
            value.batteryStatus = newBatteryStatus;
        }

        return Object.keys(value).length > 0;
    };

    useEffect(() => {
        if (detailsRow) {
            if (checkingButtonDisabled()) {
                setDisableMainButton(true);
            } else {
                setDisableMainButton(false);
            }
        } else {
            if (addAlertValue.alertName) {
                    setDisableMainButton(true);
            } else {
                setDisableMainButton(false);
            }
        }
        }, [addAlertValue, tags, listUser, descriptionValue, detailsRow]);

    const finalCreateButton = () => {
        try {
            if (detailsRow) {
                const updateList = checkingReducer();
                updateAlert(updateList);
            } else {
                const reducer = {
                    alertPolicy: {
                        name: addAlertValue.alertName,
                        isEnabled: true,
                        notifiedUsers: listUser.length > 0
                            ? listUser.map((x) => ({
                                userOid: x.oid,
                                alertOn: x.alertOn || [],
                            })) : [],
                        associatedTags: tags,
                        alertType: selectionList.value,
                        agencyOid: agencyID,
                        description: descriptionValue,
                        timezone: currentAgencyTimezone,
                        batteryStatus: {
                            lowBattery: {
                                enabled: addAlertValue?.batteryStatus?.lowBattery?.enabled,
                                threshold: addAlertValue?.batteryStatus?.lowBattery?.threshold,
                                reIntervalDays: {
                                    enabled: addAlertValue?.batteryStatus?.lowBattery?.reIntervalDays?.enabled,
                                    days: addAlertValue?.batteryStatus?.lowBattery?.reIntervalDays?.days,
                                },
                            },
                            criticalBattery: {
                                enabled: addAlertValue?.batteryStatus?.criticalBattery?.enabled,
                                threshold: addAlertValue?.batteryStatus?.criticalBattery?.threshold,
                                reIntervalDays: {
                                    enabled: addAlertValue?.batteryStatus?.criticalBattery?.reIntervalDays?.enabled,
                                    days: addAlertValue?.batteryStatus?.criticalBattery?.reIntervalDays?.days,
                                },
                            },
                            overVoltage: {
                                enabled: addAlertValue?.batteryStatus?.overVoltage?.enabled,
                                threshold: addAlertValue?.batteryStatus?.overVoltage?.threshold,
                                reIntervalDays: {
                                    enabled: addAlertValue?.batteryStatus?.overVoltage?.reIntervalDays?.enabled,
                                    days: addAlertValue?.batteryStatus?.overVoltage?.reIntervalDays?.days,
                                },
                            },
                        },
                    },
                };
                createAlert(reducer);
            }
        } catch (err) {
            console.log('error:', err);
        }
    };

    const formatTimezone = (timezone) => {
        const now = moment.tz(timezone);
        const offset = now.format('Z');
        return `${timezone.replace('_', ' ')} UTC${offset}`;
    };

    return (
    <div className="geofence-alert-details-container">
        <div className="geofence-alert-details-policy-container">
            <Text
              text="Alert Policy Name"
              weight="500"
              size="0.875rem"
              height="1.25rem"
              color="#344054"
            />
            <InputText placeholder="" value={addAlertValue.alertName} onChange={inputOnChangeAlertName} width="508px" />
        </div>
        <div className="geofence-alert-details-description-container">
            <div className="configuration-body-row">
                <div className="configuration-text-container">
                    <div className="configuration-main-text">
                        Description
                    </div>
                    <div className="configuration-supporting-text">
                        Add a brief description to further identify the alert or for specific notes
                    </div>
                </div>
                <TextArea descriptionValue={descriptionValue} setDescriptionValue={setDescriptionValue} width="535px" />
            </div>
        </div>

        {/* Actions */}
        <div className="geofence-alert-details-description-container">
            <div className="configuration-body-row">
                <div className="configuration-text-container">
                    <div className="configuration-main-text">
                        Actions
                    </div>
                </div>
            </div>
            <div>
                <div className="g-detail-action-checkbox-container" style={{ marginBottom: '16px' }}>
                    {/* Checkbox for low battery alert */}
                    <div style={{ position: 'relative', top: '3px' }}>
                        <Checkbox
                          width="16px"
                          height="16px"
                          borderRadius="4px"
                          name="lowBattery"
                          checked={addAlertValue.batteryStatus.lowBattery.enabled}
                          onChange={(e) => handleCheckboxInputAlert(e, 'lowBattery')}
                        />
                    </div>
                    <div>
                        <Text
                          text="Low Battery Alert"
                          weight="500"
                          size="0.875rem"
                          height="1.25rem"
                          color="#344054"
                        />
                        <div className="g-detail-action-checkbox-text-header">
                            Triggers the notification when the battery level
                            {' '}
                            <b>falls below</b>
                            :
                        </div>
                        <div className="g-detail-action-checkbox-text-header" style={{ marginTop: '12px' }}>
                            {/* Input for low battery percentage */}
                            <InputText
                              placeholder="00"
                              value={addAlertValue.batteryStatus.lowBattery.threshold}
                              onChange={(e) => handlePercentageInput(e, 'lowBattery')}
                              width="6rem"
                              disabled={!addAlertValue.batteryStatus.lowBattery.enabled}
                              title="Percentage"
                              textAlign="center"
                            />
                            <div className="g-detail-action-checkbox-container" style={{ marginTop: '12px' }}>
                                <div style={{ position: 'relative', top: '3px' }}>
                                    <Checkbox
                                      width="16px"
                                      height="16px"
                                      borderRadius="4px"
                                      name="reInterValDays"
                                      checked={addAlertValue.batteryStatus.lowBattery.reIntervalDays.enabled}
                                      disabled={!addAlertValue.batteryStatus.lowBattery.enabled}
                                      onChange={(e) => handleCheckBoxReInterval(e, 'lowBattery')}
                                    />
                                </div>
                                <div>
                                    <Text
                                      text="Enable re-notification based on the day interval"
                                      weight="500"
                                      size="0.875rem"
                                      height="1.25rem"
                                      color="#344054"
                                    />
                                    <div className="g-detail-action-checkbox-text-header">
                                        Triggers the notification again when the battery alert persists after the first trigger
                                    </div>
                                </div>
                            </div>
                            {/* Re-Notify */}
                            <div
                              style={{
                                marginTop: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                whiteSpace: 'nowrap',
                              }}
                            >
                                <div className="g-detail-action-checkbox-text-header" style={{ marginRight: '0.5rem' }}>
                                    Notify again every
                                </div>
                                {/* Interval Days */}
                                <InputText
                                  placeholder="0"
                                  value={addAlertValue.batteryStatus.lowBattery.reIntervalDays.days}
                                  onChange={(e) => handleIntervalDaysInput(e, 'lowBattery')}
                                  width="1.125rem"
                                  textAlign="center"
                                  disabled={!addAlertValue.batteryStatus.lowBattery.reIntervalDays.enabled}
                                />
                                <div className="g-detail-action-checkbox-text-header" style={{ marginLeft: '0.5rem' }}>
                                    days
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="g-detail-action-checkbox-container" style={{ marginBottom: '16px' }}>
                    {/* Checkbox for critical battery alert */}
                    <div style={{ position: 'relative', top: '3px' }}>
                        <Checkbox
                          width="16px"
                          height="16px"
                          borderRadius="4px"
                          name="criticalBattery"
                          checked={addAlertValue.batteryStatus.criticalBattery.enabled}
                          onChange={(e) => handleCheckboxInputAlert(e, 'criticalBattery')}
                        />
                    </div>
                    <div>
                        <Text
                          text="Critical Battery Alert"
                          weight="500"
                          size="0.875rem"
                          height="1.25rem"
                          color="#344054"
                        />
                        <div className="g-detail-action-checkbox-text-header">
                            Triggers the notification when the battery level
                            {' '}
                            <b>falls below</b>
                            :
                        </div>
                        <div className="g-detail-action-checkbox-text-header" style={{ marginTop: '12px' }}>
                            {/* Input for critical battery percentage */}
                            <InputText
                              placeholder="00"
                              value={addAlertValue.batteryStatus.criticalBattery.threshold}
                              onChange={(e) => handlePercentageInput(e, 'criticalBattery')}
                              width="6rem"
                              disabled={!addAlertValue.batteryStatus.criticalBattery.enabled}
                              title="Percentage"
                              textAlign="center"
                            />
                            <div className="g-detail-action-checkbox-container" style={{ marginTop: '12px' }}>
                                <div style={{ position: 'relative', top: '3px' }}>
                                    <Checkbox
                                      disabled={!addAlertValue.batteryStatus.criticalBattery.enabled}
                                      width="16px"
                                      height="16px"
                                      borderRadius="4px"
                                      name="reInterValDays"
                                      checked={addAlertValue.batteryStatus.criticalBattery.reIntervalDays.enabled}
                                      onChange={(e) => handleCheckBoxReInterval(e, 'criticalBattery')}
                                    />
                                </div>
                                <div>
                                    <Text
                                      text="Enable re-notification based on the day interval"
                                      weight="500"
                                      size="0.875rem"
                                      height="1.25rem"
                                      color="#344054"
                                    />
                                    <div className="g-detail-action-checkbox-text-header">
                                        Triggers the notification again when the battery alert persists after the first trigger
                                    </div>
                                </div>
                            </div>
                            {/* Re-Notify */}
                            <div
                              style={{
                                marginTop: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                whiteSpace: 'nowrap',
                              }}
                            >
                                <div className="g-detail-action-checkbox-text-header" style={{ marginRight: '0.5rem' }}>
                                    Notify again every
                                </div>
                                {/* Interval Days */}
                                <InputText
                                  placeholder="0"
                                  value={addAlertValue.batteryStatus.criticalBattery.reIntervalDays.days}
                                  onChange={(e) => handleIntervalDaysInput(e, 'criticalBattery')}
                                  width="1.125rem"
                                  textAlign="center"
                                  disabled={!addAlertValue.batteryStatus.criticalBattery.reIntervalDays.enabled}
                                />
                                <div className="g-detail-action-checkbox-text-header" style={{ marginLeft: '0.5rem' }}>
                                    days
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="g-detail-action-checkbox-container" style={{ marginBottom: '16px' }}>
                    {/* Checkbox for overvoltage alert */}
                    <div style={{ position: 'relative', top: '3px' }}>
                        <Checkbox
                          width="16px"
                          height="16px"
                          borderRadius="4px"
                          name="overvoltage"
                          checked={addAlertValue.batteryStatus.overVoltage.enabled}
                          onChange={(e) => handleCheckboxInputAlert(e, 'overVoltage')}
                        />
                    </div>
                    <div>
                        <Text
                          text="Overvoltage Alert"
                          weight="500"
                          size="0.875rem"
                          height="1.25rem"
                          color="#344054"
                        />
                        <div className="g-detail-action-checkbox-text-header">
                            Triggers the notification when voltage
                            {' '}
                            <b>exceeds</b>
                            :
                        </div>
                        <div className="g-detail-action-checkbox-text-header" style={{ marginTop: '12px' }}>
                            {/* Input for voltage */}
                            <InputText
                              placeholder="00.00"
                              value={addAlertValue.batteryStatus.overVoltage.threshold}
                              onChange={(e) => handlePercentageInput(e, 'overVoltage')}
                              width="6rem"
                              disabled={!addAlertValue.batteryStatus.overVoltage.enabled}
                              title="Voltage"
                              textAlign="center"
                            />
                            <div className="g-detail-action-checkbox-container" style={{ marginTop: '12px' }}>
                                <div style={{ position: 'relative', top: '3px' }}>
                                    <Checkbox
                                      disabled={!addAlertValue.batteryStatus.overVoltage.enabled}
                                      width="16px"
                                      height="16px"
                                      borderRadius="4px"
                                      name="reInterValDays"
                                      checked={addAlertValue.batteryStatus.overVoltage.reIntervalDays.enabled}
                                      onChange={(e) => handleCheckBoxReInterval(e, 'overVoltage')}
                                    />
                                </div>
                                <div>
                                    <Text
                                      text="Enable re-notification based on the day interval"
                                      weight="500"
                                      size="0.875rem"
                                      height="1.25rem"
                                      color="#344054"
                                    />
                                    <div className="g-detail-action-checkbox-text-header">
                                        Triggers the notification again when the battery alert persists after the first trigger
                                    </div>
                                </div>
                            </div>
                            {/* Re-Notify */}
                            <div
                              style={{
                                marginTop: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                whiteSpace: 'nowrap',
                              }}
                            >
                                <div className="g-detail-action-checkbox-text-header" style={{ marginRight: '0.5rem' }}>
                                    Notify again every
                                </div>
                                {/* Interval Days */}
                                <InputText
                                  placeholder="0"
                                  value={addAlertValue.batteryStatus.overVoltage.reIntervalDays.days}
                                  onChange={(e) => handleIntervalDaysInput(e, 'overVoltage')}
                                  width="1.125rem"
                                  textAlign="center"
                                  disabled={!addAlertValue.batteryStatus.overVoltage.reIntervalDays.enabled}
                                />
                                <div className="g-detail-action-checkbox-text-header" style={{ marginLeft: '0.5rem' }}>
                                    days
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="geofence-alert-details-areas-container">
            <div>
                <Text
                  text="Asset/Device Tags"
                  weight="500"
                  size="0.875rem"
                  height="1.25rem"
                  color="#344054"
                />
                <Text
                  text="Grant permission to tagged resources. Leave blank to grant permission to all resources"
                  weight="400"
                  size="0.875rem"
                  height="1.25rem"
                  color="#475467"
                />
            </div>
            <InputTags
              tags={tags}
              setTags={setTags}
              removedTags={removeTags}
              setRemovedTags={setRemoveTags}
              tagsHistory={tagsHistory}
            />
        </div>
        <div className="geofence-alert-details-areas-container">
            <div>
                <Text
                  text="Notified Users"
                  weight="500"
                  size="0.875rem"
                  height="1.25rem"
                  color="#344054"
                />
                <Text
                  text="Select users to be notified when selected action(s) have been triggered"
                  weight="400"
                  size="0.875rem"
                  height="1.25rem"
                  color="#475467"
                />
            </div>
            <GeofenceActionUser
              users={listUser}
              listDropdown={teamList}
              newUserFunction={addNewUser}
              userCancel={userCancel}
              disabledAddUser={disabledAddUser}
              alignment="flex-end"
              saveUser={saveUserButton}
              saveUpdateUser={saveUpdateUserButton}
              editUser={editUser}
              removeUser={removeUser}
              setSelectedOption={setSelectedOption}
              selectedOption={selectedOption}
              loading={loading}
              editingIndex={editingIndex}
              setDisabledAddUser={setDisabledAddUser}
            />
        </div>
        <div className="g-detail-button-container">
            <div className="geofence-alert-details-button">
                <SecondaryButton label="Cancel" onClickFunction={backButton} />
                <PrimaryButton label={detailsRow ? 'Update' : 'Create'} disable={!disableMainButton} loading={loading} onClickFunction={finalCreateButton} />
            </div>
        </div>
    </div>
    );
}
